import React from 'react';
import styles from '../styles.module.scss';
import { PlaceholdersSidebarTab } from '../PlaceholdersSidebarContainer';

interface TabToggleButtonsProps {
  activeTab: PlaceholdersSidebarTab;
  setActiveTab: (tab: PlaceholdersSidebarTab) => void;
}

const TabToggleButtons: React.FC<TabToggleButtonsProps> = ({ activeTab, setActiveTab }) => {
  return (
    <div className={styles.tabToggleContainer}>
      <button
        className={`${styles.tabButton} ${activeTab === PlaceholdersSidebarTab.documentFields ? styles.active : ''}`}
        onClick={() => setActiveTab(PlaceholdersSidebarTab.documentFields)}
      >
        This Document
      </button>
      <button
        className={`${styles.tabButton} ${activeTab === PlaceholdersSidebarTab.dealFields ? styles.active : ''}`}
        onClick={() => setActiveTab(PlaceholdersSidebarTab.dealFields)}
      >
        This Deal
      </button>
    </div>
  );
};

export default TabToggleButtons;
